import React from "react"
import OurPeopleFeatureComponent from "./OurPeopleFeature"
import ourPeopleFeatureFactory from "./ourPeopleFeature.factory"

export { default as OurPeopleFeatureQuery } from "./ourPeopleFeature.query"

export const OurPeopleFeature = props => {
  const { data } = props
  const componentProps = { ...props, ...ourPeopleFeatureFactory.transform(data) }
  return <OurPeopleFeatureComponent {...componentProps} />
}
